<template>
  <section>
    <div class="row mb-2">
      <div class="col-md-12 input-group">
        <span class="input-group-text">Current Organization:</span>
        <input
          type="text"
          disabled
          v-model="currentOrganization"
          class="form-control"
        />
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-5">
        <auto-suggest
          v-model="selected"
          placeholder="add an organization (type to search)"
          :filterResults="false"
          :minChars="1"
          :resolveOnLoad="false"
          :delay="750"
          :searchable="true"
          :options="searchHandler"
          trackBy="id"
          :object="true"
        />
      </div>
      <div class="col-md-1">
        <button class="btn btn-sm btn-primary mt-2" @click="addOrganization">
          Add
        </button>
      </div>
      <div class="col-md-6">
        <label for="roles" class="form-label mt-3"
          >Roles (for selected (yellow) organization)</label
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <z-table
          :value="organizations"
          sortBy="id"
          orderBy="asc"
          :columns="tableColumns"
          :isSingleRowDetail="false"
          class="table table-bordered table-striped"
          :isShowSelector="true"
        >
          <template v-slot:tbody="props">
            <td
              class="z-column-60-center"
              :class="{
                'custom-highlight': props.row.isHover,
                'custom-selected': props.row.isSelected,
              }"
              @mouseover="setHover({ id: -99 })"
            >
              <input
                v-bind:value="props.row.id"
                type="radio"
                class="custom-radio"
                v-bind:checked="selectedOrganization(props.row.id)"
                @click="radioClicked(props.row)"
              />
            </td>
            <td
              :class="{
                'custom-highlight': props.row.isHover,
                'custom-selected': props.row.isSelected,
              }"
              @click="rowClicked(props.row)"
              @mouseover="setHover(props.row)"
            >
              {{ props.row.orgCode }}
            </td>
            <td
              :class="{
                'custom-highlight': props.row.isHover,
                'custom-selected': props.row.isSelected,
              }"
              @click="rowClicked(props.row)"
              @mouseover="setHover(props.row)"
            >
              {{ props.row.orgName }}
            </td>
            <td
              class="z-column-60-center"
              :class="{
                'custom-highlight': props.row.isHover,
                'custom-selected': props.row.isSelected,
              }"
              @mouseover="setHover({ id: -99 })"
            >
              <a href="#" @click="removeOrganization(props.row)">remove</a>
            </td>
          </template>
          <template v-slot:empty> Nothing found! </template>
        </z-table>
      </div>
      <div class="col-md-6">
        <select
          v-model="selectedRoles"
          :disabled="isRolesDisabled"
          multiple="multiple"
          class="form-control custom-roles"
          name="roles"
          @click="isRoles = true"
        >
          <option
            v-for="role of roles"
            :key="role.id"
            :value="role.id"
            :selected="role.isSelected"
          >
            {{ role.name }}
          </option>
        </select>
        <button
          class="btn btn-sm btn-secondary"
          :class="{ 'btn-danger': isRoles }"
          @click="performSaveRoles"
        >
          Save Roles
        </button>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AutoSuggest from '@vueform/multiselect'
import ZTable from '@/Components/ZElements/Table'
export default {
  name: 'user-roles',
  components: {
    AutoSuggest,
    ZTable,
  },
  data() {
    return {
      isRolesDisabled: true,
      selectedRole: [],
      selected: null,
      loading: false,
      isRoles: false,
    }
  },
  mounted() {
    this.isRolesDisabled = true
    this.selected = null
    this.isRoles = false
  },
  computed: {
    ...mapGetters('users', ['user']),
    ...mapGetters('organizations', ['found']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'orgCode',
          label: 'Code',
          sortable: false,
        },
        { field: 'OrgName', label: 'Name', sortable: false },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
    currentOrganization() {
      let _data = null
      if (this.user !== undefined && this.user !== null) {
        _data = this.user.detail.organization
      }
      return _data
    },
    organizations() {
      let _data = []
      if (this.user !== undefined && this.user !== null) {
        this.user.organizations.forEach((element) => {
          let found = _data.find((x) => x.id === element.id)
          if (!found) {
            _data.push({
              id: element.id,
              orgCode: element.OrgCode,
              orgName: element.OrgName,
              isSelected: element.isSelected,
              isHover: element.isHover,
            })
          }
        })
      }
      return _data
    },
    roles() {
      let _data = []
      if (this.user !== undefined && this.user !== null) {
        this.user.roles.forEach((element) => {
          _data.push({
            id: element.id,
            name: element.label,
            isSelected: false,
          })
        })
      }
      return _data
    },
    selectedRoles: {
      get() {
        let _data = []
        if (this.user !== undefined && this.user !== null) {
          this.user.organizations.forEach((organization) => {
            if (organization.isSelected) {
              _data.push(organization.role_id)
            }
          })
        }
        return _data
      },
      set(value) {
        this.setRoles(value)
      },
    },
  },
  methods: {
    ...mapActions('users', [
      'removeOrganization',
      'setHover',
      'setSelected',
      'setCurrent',
      'setRoles',
      'getUserOrganizations',
      'saveRoles',
      'setUserData',
      'changeUserOrganization',
    ]),
    ...mapActions('organizations', [
      'findOrganizations',
      'saveUserOrganization',
      'removeUserOrganization',
    ]),
    async searchHandler(query) {
      return await this.findOrganizations(query)
    },
    selectedOrganization(id) {
      let _is = false
      if (this.user) {
        if (this.user.detail.organization_id === id) {
          _is = true
        }
      }
      return _is
    },
    async addOrganization() {
      let data = {
        user_id: this.user.detail.id,
        organization_id: this.selected.id,
      }
      await this.saveUserOrganization(data)
      await this.getUserOrganizations(this.user.detail.id)
    },
    rowClicked(row) {
      this.isRoles = false
      this.isRolesDisabled = false
      this.setSelected(row)
    },
    async radioClicked(row) {
      this.setCurrent(row)
      this.setUserData({
        name: 'organization_id',
        value: row.id,
      })
      let data = {
        user_id: this.user.detail.id,
        organization_id: row.id,
      }
      await this.changeUserOrganization(data)
    },
    async performSaveRoles() {
      let roles = []
      this.user.roles.forEach((role) => {
        if (role.isSelected) {
          roles.push(role.id)
        }
      })
      let data = {
        user_id: this.user.detail.id,
        organization_id: this.user.selectedOrganization,
        roles: roles,
      }
      await this.saveRoles(data)
      await this.getUserOrganizations(this.user.detail.id)
      this.isRoles = false
    },
    async removeOrganization(row) {
      let data = {
        user_id: this.user.detail.id,
        organization_id: row.id,
      }
      await this.removeUserOrganization(data)
      await this.getUserOrganizations(this.user.detail.id)
    },
  },
}
</script>
<style scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-organization {
  width: 100%;
  display: inline;
}
.custom-selected {
  background-color: rgba(255, 230, 0, 0.6);
}
.custom-highlight {
  cursor: pointer;
  background-color: rgba(255, 230, 0, 0.2);
}
.custom-radio {
  cursor: pointer;
}
.custom-roles {
  height: 130px;
  margin-bottom: 5px;
}
</style>
